
































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ShareClassroomUrl extends Vue {
  shareUrl = '';
  shareUrlCopied = false;

  mounted() {
    this.shareUrl = `${window.location.origin}/klas/${this.$route.params.id}`;
  }

  onCopy() {
    this.shareUrlCopied = true;
  }

  closeModal() {
    this.$parent.$emit('close-modal');
  }
}
